module.exports = __webpack_public_path__ + "img/game-btn-icon.c6782932.svg";